module.exports = __webpack_public_path__ + "static/movimiento_lateral_pivotable-0db7d3d8825879be1a29ed888d1efc1c.jpg";